<script>
    import SustainabilityCard from './sustainabilityCard.svelte';
    import IntegrationCard from './integrationCard.svelte';
    import {fade} from 'svelte/transition';
    import MarketplaceCard from './marketplaceCard.svelte';
    import EcosystemCard from './ecosystemCard.svelte';
    import PartnershipCard from './partnershipCard.svelte';
    import AmbassadorsCard from './ambassadorsCard.svelte';
    import CommunicateCard from './communicateCard.svelte';
    import GamifyCard from './gamifyCard.svelte';
    import {goto} from 'rpcjs/src/utils';
    let n = 8;
    const titles = [
        'SUSTAINABILITY',
        'INTEGRATION',
        'MARKETPLACE',
        'ECOSYSTEM',
        'PARTNERSHIP',
        'AMBASSADORS',
        'COMMUNICATE',
    ];
    let cardTitles = [];
    const updateTitles = () => {
        cardTitles = titles.slice(0, 8 - n);
    };
    /**
     * Adds two numbers together.
     */
    function next() {
        n = n - 1;
        updateTitles();
        if (n === 0) {
            setTimeout(()=>{
                goto('/traction');
            }, 100);
        }
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>
<div class="main">
    <div class="card-titles" class:fade-out={n === 0}>
        {#each cardTitles as title, titleId}
            <ul
                transition:fade={{duration: 1000}}
                role="presentation"
                on:click={() => {
                    n = 8 - titleId;
                    updateTitles();
                }}
            >
                {title}
            </ul>
        {/each}
    </div>
    <section
        role="presentation"
        on:click={next}
    >
        <div class="cards card-slidedown">
            <div class="card-rotate">
                <div class="card{n <= 0 ? '-slideup' : n}">
                    <GamifyCard />
                </div>
                <div class="card{n - 1 <= 0 ? 0 : n - 1}">
                    <CommunicateCard />
                </div>
                <div class="card{n - 2 <= 0 ? 0 : n - 2}">
                    <AmbassadorsCard />
                </div>
                <div class="card{n - 3 <= 0 ? 0 : n - 3}">
                    <PartnershipCard />
                </div>
                <div class="card{n - 4 <= 0 ? 0 : n - 4}">
                    <EcosystemCard />
                </div>
                <div class="card{n - 5 <= 0 ? 0 : n - 5}">
                    <MarketplaceCard />
                </div>
                <div class="card{n - 6 <= 0 ? 0 : n - 6}">
                    <IntegrationCard />
                </div>
            </div>
            <div class="card{n - 7 <= 0 ? 0 : n - 7}">
                <SustainabilityCard />
            </div>
        </div>
        <div class="blocks {n === 0 ? 'slide-left': 'text-slideup'}">
            <p class="building-text">BUILDING</p>
            <p class="blocks-text">BLOCKS</p>
        </div>
    </section>
</div>

<style>
    .cards{
        position: absolute;
        height: 47.917vw;
        width: 100%;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .main {
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    .card-titles {
        position: absolute;
        z-index: 10;
        top: 13.802vw;
        left: 0.677vw;
        font-weight: 900;
        font-size: 1.563vw;
        line-height: 74.5%;
        color: #3e3e3e;
        font-family: 'Montserrat';
        cursor: pointer;
    }
    ul {
        padding: 0;
        margin: 0;
    }
    .card-titles ul {
        margin-bottom: 0.677vw;
    }
    section {
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .card0 {
        position: absolute;
        left: 44.34vw;
        transform: translateX(70vw);
        transition: 1000ms;
    }
    .card1 {
        position: absolute;
        left: 44.34vw;
        transition: 1000ms;
    }
    .card2 {
        position: absolute;
        top: 2.225vw;
        left: 33.512vw;
        transform: scale(0.6906) rotate(-20deg);
        transition: 1000ms;
    }
    .card3 {
        position: absolute;
        top: 1.325vw;
        left: 31vw;
        transform: scale(0.6906) rotate(-30deg);
        transition: 1000ms;
    }
    .card4 {
        position: absolute;
        top: 1.125;
        left: 28.5vw;
        transform: scale(0.6906) rotate(-40deg);
        transition: 1000ms;
    }
    .card5 {
        position: absolute;
        top: 1vw;
        left: 25.978vw;
        transform: scale(0.6906) rotate(-50deg);
        transition: 1000ms;
    }
    .card6 {
        position: absolute;
        left: 23.792vw;
        top: 0vw;
        transform: scale(0.6906) rotate(-60deg);
        transition: 1000ms;
    }
    .card7 {
        position: absolute;
        left: 19.551vw;
        top: 0vw;
        transform: scale(0.6906) rotate(-70deg);
        transition: 1000ms;
    }
    .card8 {
        position: absolute;
        left: 16.6vw;
        top: 0vw;
        transform: scale(0.6906) rotate(-80deg);
        transition: 1000ms;
    }
    .blocks {
        position: absolute;
        height: fit-content;
        left: -0.677vw;
        font-family: "Montserrat";
        font-style: normal;
        color: #ffffff;
        font-weight: 900;
        bottom: 11vh;
    }
    .building-text {
        font-size: 9.259vh;
    line-height: 7.315vh;
    }
    .blocks-text {
        font-weight: 900;
        font-size: 13.889vh;
        line-height: 10.926vh;
        color: #ffcc33;
        position: absolute;
    }
    p {
        padding: 0;
        margin: 0;
    }
    /* Card Slideup only apply on card 8 when new page has to pop up */
    .card-slideup {
        position: absolute;
        top: 4.175vw;
        left: 44.34vw;
        animation: slideUp 1000ms forwards;
        transition: 1000ms;
    }
    @keyframes slideUp {
        100% {
            transform: translateY(-70vw);
        }
    }
    .slide-left {
        animation: slideLeft 1000ms forwards;
        transition: 1000ms;
    }
    @keyframes slideLeft {
        100% {
            transform: translateX(-70vw);
        }
    }
    .text-slideup {
        animation: textSlideup 1000ms forwards;
        transition: 1000ms;
    }
    @keyframes textSlideup {
        0% {
            transform: translateY(20vw);
        }
    }
    .fade-out {
        animation: fadeOut 1000ms forwards;
        transition: 1000ms;
    }
    @keyframes fadeOut {
        100% {
            opacity: 0;
        }
    }
    .card-slidedown {
        animation: slideDown 1000ms forwards;
    }
    @keyframes slideDown {
        0% {
            transform: translateY(-60vw);
            opacity: 1;
        }
    }
    .card-rotate {
        animation: rotate 1000ms forwards;
    }
    @keyframes rotate {
        0% {
            transform: rotate(30deg);
            opacity: 1;
        }
    }
</style>
